import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import State, { List } from './states'
import _ from 'lodash'
import axios from 'axios'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<State> = {
  [mutationType.GET_LISTS](
    state: State,
    data: List,
  ): void {
    state.list = data
  },
}

export default mutations
